// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';

import StaffUser, { StaffUserDTO } from '@shared/models/staff-user';
import container from '@core/di';
import StaffService from '@shared/services/staff';
import BaseStore from '@core/stores/base';

@injectable()
export default class StaffStore extends BaseStore<StaffUserDTO, StaffUser, StaffService> {
  static diToken = Symbol('staff-store');

  constructor() {
    super({ service: container.get<StaffService>(StaffService.diToken) });
  }

  validateActivationLink(userId: StaffUser['id'], token: string) {
    return this.service.validateActivationLink(userId, token);
  }

  activateAccount(userId: StaffUser['id'], data: { resetPasswordToken: string; newPassword: string; }) {
    return this.service.activateAccount(userId, data);
  }

  resetPassword(email: string) {
    return this.service.resetPassword(email);
  }

  validateRecoveryLink(userId: StaffUser['id'], token: string) {
    return this.service.validateRecoveryLink(userId, token);
  }

  setNewPassword(userId: StaffUser['id'], data: { newPassword: string; confirmPassword: string; token: string; }) {
    return this.service.setNewPassword(userId, data);
  }

  resendInvitation(userId: StaffUser['id']) {
    return this.service.resendInvitation(userId);
  }
}
